// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import type {
  MarginProperties,
  PaddingProperties,
  Spacing,
} from '@iheartjane/reefer';
import { spacing } from '@iheartjane/reefer-emotion';
import type { CSSProperties } from 'react';

export interface GridProps extends MarginProperties, PaddingProperties {
  columnGap?: Spacing;
  gap?: Spacing;
  gridTemplateColumns?: string;
  position?: CSSProperties['position'];
  rowGap?: Spacing;
}

const calculateProp = (prop?: Spacing): string | undefined => {
  if (prop === undefined) return;
  return !isNaN(parseInt(prop as string)) ? `${prop}px` : `${prop}`;
};

export const Grid = styled('div')<GridProps>(
  ({ columnGap, gap, gridTemplateColumns, position, rowGap, ...rest }) => ({
    columnGap: columnGap ? calculateProp(columnGap) : calculateProp(gap),
    display: 'grid',
    gridTemplateColumns,
    position,
    rowGap: rowGap ? calculateProp(rowGap) : calculateProp(gap),
    ...spacing(rest),
  })
);
